// config.demo.js
//
// Centre DEMO (matricula.dieres.com): entorn de demostració del
// funcionament de la plataforma, basat en la configuració real de cavall
// bernat però SENSE cap dada personal real (dump anonimitzat, veure
// inscripcions_api/scramble.php) i sense cap passarel·la de pagament activa.

const config =
{
    cid: 'demo',

    // llistat dels camps d'autorització del pas "Protecció de dades" d'aquest centre
    // (veure src/components/enrolmentform/authorizations/demo/)
    autoritzacions: [
        'authAlcohol', 'authAMPA', 'authCompromis', 'authDretsImatge', 'authGDPR',
        'authLlibresSocialitzats', 'authMedica', 'authMobils', 'authPagament',
        'authPortatils', 'authResponsable', 'authSortides',
    ],

    phone: "645621660",
    email: "info@dieres.com",

    headerLogo:  'img/logo_bn_demo.png',
    headerTitle:  'Centre DEMO',
    headerURL: 'https://matricula.dieres.com/',

    enrollmentPostURL: '/post/',
    apiURL: '/api/',

    popupInicial: false,

    adjuntarArxiusNoObligatori: false,

    validaIDdocuments: false,
    tipusDocTSI: true,

    fotoCarnet: true,
    validaIAfotoCarnetFile: false,
    validaIAiddocumentFrontFile: false,

    telefonObligatori: true,
    carnetFamiliaNombrosa: false,

    contacteEmergenciaObligatori: true,

    adjuntMedic: true,
    adjuntMedicObligatori: false,

    datesNoBloquejenInscripcio: false,

    noPreguntarSiEsNouAlumne: false,

    notesAcces: false,

    mostraTorns: false,

    demanaConvalidacions: false,

    logo: 'img/logo_demo.jpg',
    titol: 'DEMO',

    favicon: '/img/favicon-demo.ico',
    faviconGestio: '/gestio/img/favicon-demo.ico',

    assignatures: 'assignatures/assignatures.demo.json',
    families: 'families/families.demo.json',
    dadesbancaries: 'dadesbancaries/dadesbancaries.demo.json',
    calculquota: 'quotes.demo.json',

    treballantFile: true,
    necessitatsEducativesEspecials: true,

    repetidor: false,
    repetidorsNoPodenAgafarAssignaturesDe2n: false,

    textDadesMediquesAlgunSi: "",

    textBotoMatricular: "INSCRIURE",

    proporcionarPreinscripcioNous: true,
    proporcionarTitolPreinscripcioNous: true,

    textAlumneNouAlCentre: "Ets alumne nou als estudis que et matricules?",
    textAlumneNouAlCentreSub: null,

    // sense passarel·la de pagament real: entorn purament de demostració
    urlTPV: "https://matricula.dieres.com/tpv/",
    pagamentTPV: true,
    pagamentTransferencia: false,

    textInscripcioText: null,

    dosTerminisDefault: false,
    dosTerminisAmagaBoto: true,

    textTerminis: [ "(amb la matrícula)", null, null ],

    dosTerminisEnabled: false,
    dosTerminisEnabledFalseCondicio: 0,

    sexeNoBinari: true,

    // documents de prova ja reconeguts per la resta del codi (veure
    // inscripcions_api/index.php i inscripcions_api/scramble.php)
    su: ['WyIxMTExMTEx', 'MUgiLCIyMjIyMjIyM', 'koiLCI0NTQ5MjQwNVMiXQ=='],
};

export default config;
